import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { GoalsParams, GoalsService } from 'superlikers-microsites-api'

import { adapterSprint } from '@core/adapters/sprints.adapter'
import { Sprint } from '@core/interfaces/sprints.interface'
import { User } from '@core/interfaces/participant.interface'

/**
 * Servicio para gestionar los sprints
 * Se encarga de realizar las peticiones al API de Goals con el tag 'sprint'
 * y transformar los datos externos al modelo interno Sprint
 */
@Injectable({
  providedIn: 'root'
})
export class SprintsService {
  private goalsService = inject(GoalsService)

  /**
   * Obtiene los sprints para un usuario específico
   *
   * @param {User} user - Usuario para el que obtener los sprints
   * @param {number} page - Número de página para la paginación (por defecto: 1)
   * @returns {Observable<Sprint[]>} Observable con array de sprints adaptados
   */
  fetchSprints(user: User, page = 1): Observable<Sprint[]> {
    const params: GoalsParams = { page, tags: ['sprint'] }
    if (user) params['participant_uid'] = user.uid

    const goals$ = this.goalsService.getGoals(params).pipe(map(response => response.data))
    return goals$.pipe(map(goals => goals.map(goal => adapterSprint(user.uid, goal))))
  }
}
